<template>
  <section class="start-teaching-about">
    <BaseTitleSection :title="title" />
    <p class="start-teaching-about__text">
      {{ text }}
    </p>
    <CommonContinueRegistration btn-class="mx-auto mt-8 lg:w-[250px] w-[190px]">
      <template #else>
        <BaseButton
          :label="$t('actions.join_as_tutor')"
          class="lg:w-[230px] w-[160px] mx-auto mt-8"
          @click="$emit('signup')"
        />
      </template>
    </CommonContinueRegistration>

    <div v-if="getStatistics" class="start-teaching-about__statistics">
      <div v-for="item in getStatistics" :key="item.number" class="start-teaching-about__stat">
        <div class="text-center">
          <p class="text__headline-3-xs--bold lg:text__headline-4-md--bold text-title">
            {{ item.number }}
          </p>
          <p class="text__body-2-xs--regular lg:text__body-2-md--regular mt-2 text-body-1">
            {{ item.title }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BaseTitleSection from '@design-system/base/title/title-section.vue'
import { mapGetters } from 'vuex'
import staticData from './static-data'
import CommonContinueRegistration from '~/components/common/continue-registration.vue'
export default {
  name: 'StartTeachingAboutUs',
  components: { CommonContinueRegistration, BaseTitleSection },
  data () {
    return {
      ...staticData
    }
  },
  computed: {
    ...mapGetters('global', ['getStatistics'])
  }
}
</script>

<style scoped lang="scss">
.start-teaching-about {
  @apply container;
  &__text {
    @apply lg:text__body-2-md--regular text__caption-xs--regular text-body-2 mt-6 lg:mt-12;
  }
  &__statistics {
    @apply flex justify-center lg:space-x-4 mt-8 flex-col lg:flex-row space-y-4 lg:space-y-0
    items-center;
  }
  &__stat {
    @apply bg-primary-100 w-[188px] h-[116px] lg:h-[156px] rounded-2xl flex items-center justify-center;
  }
}
</style>
